module.exports = __webpack_public_path__ + "img/icon_comm.57b6ef2a.svg";